import { useState } from 'react';
import { identity } from 'lodash-es';

type AsyncState<T> = {
  data: T | undefined;
  error: unknown;
  loading: boolean;
};

type AsyncFn = (...params: unknown[]) => Promise<void>;

export const useAsync = <T = unknown>(
  fn: (...params: unknown[]) => Promise<T>,
  parseError: (error: unknown) => unknown = identity
): [AsyncState<T>, AsyncFn] => {
  const [error, setError] = useState<unknown>(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<T | undefined>(undefined);

  const asyncFn = async (...params: unknown[]) => {
    setError(null);
    setLoading(true);
    try {
      const data = await fn(...params);
      setData(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setError(parseError(e));
    }
  };

  return [{ data, error, loading }, asyncFn];
};
